// extracted by mini-css-extract-plugin
export default {"card":"Blocks_card__eHa6i","title":"Blocks_title__LW52Y","desc":"Blocks_desc__WxDkF"};